import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.25 14.75H11.75C12.5784 14.75 13.25 14.0784 13.25 13.25V5.25V2.75C13.25 1.92157 12.5784 1.25 11.75 1.25H4.25C3.42157 1.25 2.75 1.92157 2.75 2.75V13.25C2.75 14.0784 3.42157 14.75 4.25 14.75Z"
            fill="#DEDEDE"
            stroke="#818181"
            strokeWidth="0.75"
        />
        <rect fill="#3C3C3C" height="5" rx="1" width="9" x="1" y="8.5" />
        <path
            d="M2 12.6707H4.50269V12.0225H2.95142V12.0071L4.45435 10.012V9.5H2.02417V10.1482H3.50732V10.1636L2 12.1587V12.6707Z"
            fill="#FDFDFD"
        />
        <path
            d="M5.06396 12.6707H5.87035V9.5H5.06396V12.6707Z"
            fill="#FDFDFD"
        />
        <path
            d="M6.48655 12.6707H7.29295V11.7412H7.83787C8.54539 11.7412 9.00242 11.3062 9.00242 10.6272V10.6228C9.00242 9.94385 8.54539 9.5 7.83787 9.5H6.48655V12.6707ZM7.64451 10.1174C7.98509 10.1174 8.18724 10.2932 8.18724 10.6228V10.6272C8.18724 10.9568 7.98509 11.1348 7.64451 11.1348H7.29295V10.1174H7.64451Z"
            fill="#FDFDFD"
        />
        <path
            d="M8.94612 2.76942L9.15194 1.74029C9.20896 1.45521 9.45927 1.25 9.75 1.25C10.0407 1.25 10.291 1.45521 10.3481 1.74029L10.5539 2.76942C10.6553 3.27671 10.2673 3.75 9.75 3.75C9.23267 3.75 8.84466 3.27671 8.94612 2.76942Z"
            fill="#FDFDFD"
            stroke="#818181"
            strokeWidth="0.75"
        />
        <path
            d="M9.75 4.75V5.25"
            stroke="#818181"
            strokeLinecap="round"
            strokeWidth="0.75"
        />
        <path
            d="M9.75 6.75V7.25"
            stroke="#818181"
            strokeLinecap="round"
            strokeWidth="0.75"
        />
    </svg>
);

export default Icon;
